<div class="container-fluid">
    <div class="row mt-10">
        <div class="col-md-6 title">Notified on</div>
        <div class="col-md-6">{{Instruction.createdOn}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Notified by</div>
        <div class="col-md-6">{{Instruction.createdBy}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Unit</div>
        <div class="col-md-6">{{Instruction.units}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued From</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDateOnly(Instruction.issuedFrom)}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued To</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDateOnly(Instruction.issuedTo)}}</div>
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Date Comments</div>
        <div class="col-md-6">{{Instruction.dateComment}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Status</div>
        <div class="col-md-6">{{Instruction.status}}
        @if(Instruction.isArchived){
            - Archived
       }
        </div>
    </div>
    
    @if(Instruction.status == 'New' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Acknowledged')">
                Acknowledge
            </nj-button>
        </div>
    </div>}

    @if(Instruction.status == 'Acknowledged' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Completed')">
                Complete
            </nj-button>
        </div>
    </div>}
    <!-- Archive / UnArchive -->
    @if(UserService.getUser()?.CanArchive){
        <div class="row mt-10">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <nj-button size="normal" type="button" [isDisabled]="false" icon=""
                    [hasCustomIcon]="false" (buttonClick)="ChangeStatus(Instruction.isArchived ? 'UnArchive' : 'Archive')">
                    {{ Instruction.isArchived ? 'Unarchive' : 'Archive' }}
                </nj-button>
            </div>
        </div>}

    <div class="row title  mt-10 col-md-12">
        1-Water Commitment
    </div>

    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.instructionData.waterCommitment)"></div>

    <div class="row title mt-10 col-md-12">
        2- Indicative max contract book commitment (generation) split by EFA block
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="col-md-1">EFA Block</th>
                        <th class="col-md-6">Max Contract Book Commitment</th>
                    </tr>
                </thead>
                <tbody>
                    @for(EFA of Instruction.instructionData.maxContractEFABlocks; track
                    Instruction.instructionData.maxContractEFABlocks;let i = $index) {
                    <tr>
                        <td>
                            {{EFA.efa}}
                        </td>
                        <td>
                            {{EFA.text}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.instructionData.maxContractBookCommitmentByEFABlocks)"></div>
    <div class="row title mt-10 col-md-12">
        3- Trading & BM Spreads
    </div>
    <div class="row col-md-12">
        · Target spreads for selling additional generation at Ffes units:
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">

                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th colspan="1">Duty</th>
                        <th colspan="2" class="subDiv">Minimum Target Trading Spread(£/MWh)</th>
                        <th colspan="4" class="subDiv">Minimum Target BM Spreads (£/MWh)</th>
                    </tr>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="rowSubDiv"></th>
                        <th>Into Gen</th>
                        <th class="rowSubDiv">Buy Back Position</th>
                        <th>Offer Into Gen</th>
                        <th>Offer Out of Pump</th>
                        <th>BID Down from Gen</th>
                        <th class="rowSubDiv">BID into Pump</th>
                    </tr>
                </thead>
                <tbody>
                    @for(spread of Instruction.instructionData.spreadsFFES; track
                    Instruction.instructionData.spreadsFFES;let i = $index) {
                    <tr>
                        <td>
                            {{spread.duty}}
                        </td>
                        <td>
                            {{spread.trading_IntoGen}}
                        </td>
                        <td>{{spread.trading_BuyBackPosition}}</td>
                        <td>{{spread.bM_OfferIntoGen}}</td>
                        <td>{{spread.bM_OfferOutOfPump}}</td>
                        <td>{{spread.bM_BidDownFromGen}}</td>
                        <td>{{spread.bM_BidIntoPump}}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class="row mt-10 col-md-12">
        · Target spreads for selling additional generation at Dino units:
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="maxContractEFABlocks" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th colspan="1">Duty</th>
                        <th colspan="2" class="subDiv">Minimum Target Trading Spread(£/MWh)</th>
                        <th colspan="4" class="subDiv">Minimum Target BM Spreads (£/MWh)</th>
                    </tr>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th class="rowSubDiv"></th>
                        <th>Into Gen</th>
                        <th class="rowSubDiv">Buy Back Position</th>
                        <th>Offer Into Gen</th>
                        <th>Offer Out of Pump</th>
                        <th>BID Down from Gen</th>
                        <th class="rowSubDiv">BID into Pump</th>
                    </tr>
                </thead>
                <tbody>
                    @for(spread of Instruction.instructionData.spreadsDINO; track
                    Instruction.instructionData.spreadsDINO;let i = $index) {
                    <tr>
                        <td>
                            {{spread.duty}}
                        </td>
                        <td>
                            {{spread.trading_IntoGen}}
                        </td>
                        <td>{{spread.trading_BuyBackPosition}}</td>
                        <td>{{spread.bM_OfferIntoGen}}</td>
                        <td>{{spread.bM_OfferOutOfPump}}</td>
                        <td>{{spread.bM_BidDownFromGen}}</td>
                        <td>{{spread.bM_BidIntoPump}}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
    <div class=" row col-md-12 mt-10">{{Instruction.instructionData.spreads}}</div>
    <div class="row title mt-10 col-md-12">
        4 - Key uncertainties
    </div>
    <div class=" row col-md-12" [innerHTML]="Formatext(Instruction.instructionData.keyUncertainties)"></div>
    <div class="row title mt-10 col-md-12">
        5 - Quick Reserve
    </div>

    <div class="row">
        Pricing Targets
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="quickReservePricingTarget" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Time</th>
                        <th>Station</th>
                        <th>Service</th>
                        <th>Pricing</th>
                    </tr>
                </thead>
                <tbody>
                    @for(target of Instruction.instructionData.quickReservePricingTarget; track
                    Instruction.instructionData.quickReservePricingTarget; let i = $index){
                    <tr>
                        <td>{{target.time}}</td>
                        <td>{{target.station}}</td>
                        <td>{{target.service}}</td>
                        <td>{{target.pricing}}</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        Standing Limits
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="quickReserveStandingLimits" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Service</th>
                        <th>Parameter</th>
                        <th>Station</th>
                        <th>Comment</th>
                    </tr>
                </thead>
                <tbody>
                    @for(limit of Instruction.instructionData.quickReserveStandingLimits; track
                    Instruction.instructionData.quickReserveStandingLimits; let i = $index){
                    <tr>
                        <td>{{limit.service}}</td>
                        <td>{{limit.parameter}}</td>
                        <td>{{limit.station}}</td>
                        <td>{{limit.comment}}</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    </div>
    <div class=" row col-md-12">{{Instruction.instructionData.quickReserve}}</div>


    <div class="row title mt-10 col-md-12">
        6 - Minimum Bid Prices
    </div>

    <div class="row">
        · Mimimum Bid Prices
    </div>
    <div class="row">
        <div class="col-md-12">
            <table id="minimumBidPricesTarget" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">
                        <th>Station</th>
                        <th>Type</th>
                        <th>No technical restrictions (£/MWh)</th>
                        <th>Technical restrictions (£/MWh)</th>
                    </tr>
                </thead>
                <tbody>
                    @for(minBid of Instruction.instructionData.minimumBidPrices; track
                    Instruction.instructionData.minimumBidPrices; let i = $index){
                    <tr>
                        <td>{{minBid.station}}</td>
                        <td>{{minBid.type}}</td>
                        <td>{{minBid.noTechnicalRestrictions}}</td>
                        <td>{{minBid.technicalRestrictions}}</td>
                    </tr>}
                </tbody>
            </table>
        </div>
    </div>
    <div class="row">
        · When a First Hydro unit is on a long term outage, please refer to the below table:
    </div>
    <div class="row">
        <div class="col-md-4">
            <table id="minimumBidPricesTarget" class="nj-table nj-table--hover nj-table--striped nj-cursor">
                <thead>
                    <tr [style]="'background-color: #d8d8d8'">

                        <th>Type</th>
                        <th>(£/MWh)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Offer Price</td>
                        <td>{{Instruction.instructionData.minimumBidPriceLongOutageOfferPrice}}</td>
                    </tr>

                    <tr>
                        <td>Bid Price</td>
                        <td>{{Instruction.instructionData.minimumBidPriceLongOutageBidPrice}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</div>